import { useFields } from './Fields.h'

import { Controller } from 'react-hook-form'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import FormControlLabel from '@mui/material/FormControlLabel'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import IconButton from '@mui/material/IconButton'
import FormTextField from '@shared/components/FormTextField'
import Images from './Images'
import AddIcon from '@mui/icons-material/Add'
import PostAddIcon from '@mui/icons-material/PostAdd'
import Attachments from './Attachments'
import Signature from './Signature'

export default function Fields() {
    const {
        instance,
        handleClose,
        isPending,
        workType,
        control,
        dialogMode,

        tab,
        setTab,

        viewDocs,
        viewCropper,

        images,
        imgUploaderRef,
        uploadImage,

        attachments,
        atchUploaderRef,
        uploadAttachment,

        offices
    } = useFields()

    return (
        <>
            {offices.isLoading && <LinearProgress sx={{height: 10}}/>}
            {dialogMode == 'fields' &&
                <>
                    <DialogTitle>{instance ? 'تعديل' : 'إضافة'}</DialogTitle>
                    <Tabs
                        value={tab}
                        onChange={(e, v) => setTab(v)}
                        variant='scrollable'
                        scrollButtons
                        allowScrollButtonsMobile
                        sx={{borderBottom: '1px solid #77777750'}}
                    >
                        <Tab value='general' label='عام'/>
                        <Tab value='documents' sx={{display: workType === 'ready_files' ? 'none' : 'block'}} label={`النماذج (${images.filter(img => img.dep === 'documents').length})`}/>
                        <Tab value='location' sx={{display: workType === 'ready_files' ? 'none' : 'block'}} label={`الموقع (${images.filter(img => img.dep === 'location').length})`}/>
                        <Tab value='violations' sx={{display: workType === 'ready_files' ? 'none' : 'block'}} label={`مخالفات السلامة (${images.filter(img => img.dep === 'violations').length})`}/>
                        <Tab value='ready_files' sx={{display: workType === 'ready_files' ? 'block' : 'none'}} label={`المرفقات (${attachments.length})`}/>
                    </Tabs>
                </>
            }
            <DialogContent sx={{display: dialogMode == 'fields' ? 'block' : 'none'}}>
                <Stack sx={{display: tab === 'general' ? 'auto' : 'none'}}>
                    <FormTextField
                        name='number'
                        label='رقم المقايسة *'
                    />
                    <FormTextField
                        name='contractor'
                        label='المقاول *'
                    />
                    <FormTextField
                        name='work_type'
                        label='نوع العمل'
                        defaultValue='meter_installation'
                        select
                    >
                        <ListSubheader sx={{bgcolor: 'transparent'}}>المشتركين</ListSubheader>
                        <MenuItem value='meter_installation'>عداد</MenuItem>
                        <MenuItem value='network_connection'>تنفيذ شبكة</MenuItem>
                        <ListSubheader sx={{bgcolor: 'transparent'}}>العمليات والصيانة</ListSubheader>
                        <MenuItem value='emergency_response'>طوارئ</MenuItem>
                        <MenuItem value='asset_replacement'>إحلال</MenuItem>
                        <MenuItem value='network_upgrade'>التعزيز</MenuItem>
                        <MenuItem value='medium_voltage_operations'>الجهد المتوسط</MenuItem>
                        <ListSubheader sx={{bgcolor: 'transparent'}}>أخرى</ListSubheader>
                        <MenuItem value='projects'>المشاريع</MenuItem>
                        <MenuItem value='assets'>الأصول</MenuItem>
                        <MenuItem value='ready_files'>ملفات جاهزة</MenuItem>
                    </FormTextField>
                    {workType === 'assets' && (
                        <Box sx={{
                            display: 'flex',
                            gap: 2
                        }}>
                            <FormTextField
                                name='equipment_no'
                                label='رقم المُعدّة'
                            />
                            <FormTextField
                                name='site_type'
                                label='نوع الموقع'
                                defaultValue='cns'
                                select
                            >
                                <MenuItem value='cns'>CNS</MenuItem>
                                <MenuItem value='cds'>CDS</MenuItem>
                            </FormTextField>
                        </Box>
                    )}
                    <FormTextField
                        name='office'
                        label='المكتب'
                        defaultValue={instance?.office || ''}
                        select
                    >
                        <MenuItem value=''>---------</MenuItem>
                        {(!offices.isLoading && !offices.error) && (
                            offices.data.map(office => (
                                <MenuItem
                                    key={office.id}
                                    value={office.id}
                                >{office.name}</MenuItem>
                            ))
                        )}
                    </FormTextField>
                    <Controller
                        name='is_draft'
                        control={control}
                        defaultValue={false}
                        render={({ field }) => 
                            <FormControlLabel
                                sx={{my: 2}}
                                control={
                                    <Checkbox {...field} checked={field.value} />
                                }
                                label={
                                    <Box>
                                        <Typography variant='body1'>مؤرشفة</Typography>
                                        <Typography variant='caption' color='text.secondary'>مؤرشفة تعني قيد التنفيذ</Typography>
                                    </Box>
                                }
                            />
                        }
                    />
                    <Typography variant='caption'>بيانات إختيارية</Typography>
                    <FormTextField
                        name='supervisor_name'
                        label='اسم المشرف'
                    />
                    <Signature />
                    <FormTextField
                        name='station_no'
                        label='رقم المحطة'
                    />
                    <FormTextField
                        name='notes'
                        label='الملاحظات'
                        rows={4}
                        multiline
                    />
                </Stack>
                <input
                    type='file'
                    accept='image/png,image/jpeg,image/webp'
                    ref={imgUploaderRef}
                    onChange={uploadImage}
                    multiple
                    hidden
                />
                <input
                    type='file'
                    accept='.pdf,application/pdf'
                    ref={atchUploaderRef}
                    onChange={uploadAttachment}
                    multiple
                    hidden
                />
                {/* Documents */}
                <Box sx={{
                    display: tab === 'documents' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {images.filter(image => image.dep === 'documents').length === 0
                        ? (<>
                            <Typography>ما من نماذج</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => imgUploaderRef.current.click()}
                                >إضافة صور</Button>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={viewDocs}
                                >نموذج رقمي</Button>
                            </Box>
                        </>) : (
                            <>
                                <Box sx={{
                                    width: '100%',
                                    mb: 1
                                }}>
                                    <Tooltip title='إضافة صور'>
                                        <IconButton onClick={() => imgUploaderRef.current.click()}><AddIcon /></IconButton>
                                    </Tooltip>
                                    <Tooltip title='نموذج رقمي'>
                                        <IconButton onClick={viewDocs}><PostAddIcon /></IconButton>
                                    </Tooltip>
                                </Box>
                                <Images
                                    images={images.filter(image => image.dep === 'documents')}
                                    onCrop={viewCropper}
                                />
                            </>
                        )
                    }
                </Box>

                {/* Location */}
                <Box sx={{
                    display: tab === 'location' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {images.filter(image => image.dep === 'location').length === 0
                        ? (<>
                            <Typography>ما من صور</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => imgUploaderRef.current.click()}
                                >إضافة صور</Button>
                            </Box>
                        </>) : (<>
                            <IconButton
                                sx={{
                                    alignSelf: 'end',
                                    mb: 1
                                }}
                                onClick={() => imgUploaderRef.current.click()}
                            ><AddIcon /></IconButton>
                            <Images
                                images={images.filter(image => image.dep === 'location')}
                                onCrop={viewCropper}
                            />
                        </>)
                    }
                </Box>

                {/* Violations */}
                <Box sx={{
                    display: tab === 'violations' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {images.filter(image => image.dep === 'violations').length === 0
                        ? (<>
                            <Typography>ما من صور</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => imgUploaderRef.current.click()}
                                >إضافة صور</Button>
                            </Box>
                        </>) : (<>
                            <IconButton
                                sx={{
                                    alignSelf: 'end',
                                    mb: 1
                                }}
                                onClick={() => imgUploaderRef.current.click()}
                            ><AddIcon /></IconButton>
                            <Images
                                images={images.filter(image => image.dep === 'violations')}
                                onCrop={viewCropper}
                            />
                        </>)
                    }
                </Box>

                {/* Ready files */}
                <Box sx={{
                    display: tab === 'ready_files' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {attachments.length === 0
                        ? (<>
                            <Typography>ما من مرفقات</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button variant='contained' onClick={() => atchUploaderRef.current.click()}>إضافة مرفق</Button>
                            </Box>
                        </>) : (<>
                            <IconButton
                                sx={{
                                    alignSelf: 'end',
                                    mb: 1
                                }}
                                onClick={() => atchUploaderRef.current.click()}
                            ><AddIcon /></IconButton>
                            <Attachments
                                attachments={attachments}
                            />
                        </>)
                    }
                </Box>
            </DialogContent>
            <DialogActions sx={{display: dialogMode == 'fields' ? 'flex' : 'none'}}>
                <Button
                    variant='text'
                    onClick={handleClose}
                    disabled={isPending}
                >إغلاق</Button>
                <Button
                    variant='text'
                    type='submit'
                    disabled={isPending}
                >حفظ</Button>
            </DialogActions>
        </>
    )
}